import React from 'react';
import { formatFecha, formatHora } from '../../utils/formatos';
import { Spinner } from '../common/ui';

export default function TablaConsultas({ consultas, loading, onVerInforme }) {
    if (loading) {
        return (
            <div className="p-12 text-center text-slate-500 font-bold bg-white rounded-3xl border border-slate-200">
                <Spinner size="md" className="mx-auto mb-3" />
                Cargando histórico clínico...
            </div>
        );
    }

    if (!consultas || consultas.length === 0) {
        return (
            <div className="p-12 text-center text-slate-500 bg-white rounded-3xl border border-slate-200">
                <h3 className="font-black text-lg text-slate-700">Registro vacío</h3>
                <p className="text-sm font-medium mt-1">No hay actos médicos registrados en el sistema.</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto bg-white rounded-3xl border border-slate-200 shadow-sm">
            <table className="w-full text-left border-collapse text-sm">
                <thead className="bg-slate-50 border-b border-slate-100 text-slate-400 font-black text-[11px] uppercase tracking-widest">
                <tr>
                    <th className="px-6 py-5">Fecha / Hora</th>
                    <th className="px-6 py-5">Paciente</th>
                    <th className="px-6 py-5">Motivo de Asistencia</th>
                    <th className="px-6 py-5">Estado</th>
                    <th className="px-6 py-5 text-right">Documentación</th>
                </tr>
                </thead>
                <tbody className="divide-y divide-slate-100/80">
                {consultas.map((consulta) => {
                    const esCompletada = consulta.estado === 'completada';
                    const nombrePaciente = consulta.paciente ? `${consulta.paciente.nombre} ${consulta.paciente.apellidos}` : 'Paciente Desconocido';

                    return (
                        <tr key={consulta.id || consulta._id} className="hover:bg-slate-50/80 transition-colors group">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex flex-col">
                                    <span className="font-black text-slate-700">{formatFecha(consulta.fecha)}</span>
                                    <span className="text-xs font-bold text-slate-400">{formatHora(consulta.fecha)} hrs</span>
                                </div>
                            </td>
                            <td className="px-6 py-4 font-bold text-slate-900">{nombrePaciente}</td>
                            <td className="px-6 py-4 text-slate-600 line-clamp-2">{consulta.motivo || 'No especificado'}</td>
                            <td className="px-6 py-4">
                                    <span className={`px-3 py-1 text-[10px] font-black uppercase tracking-wider rounded-lg border ${
                                        esCompletada
                                            ? 'bg-emerald-50 text-emerald-700 border-emerald-200/60'
                                            : 'bg-amber-50 text-amber-700 border-amber-200/60'
                                    }`}>
                                        {consulta.estado}
                                    </span>
                            </td>
                            <td className="px-6 py-4 text-right">
                                <button
                                    onClick={() => onVerInforme(consulta)}
                                    className="px-4 py-2 text-xs font-bold text-blue-700 bg-blue-50 border border-blue-100 rounded-xl hover:bg-blue-600 hover:text-white shadow-sm transition-all"
                                >
                                    Ver Informe
                                </button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
}